import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import history from '../../../history';
import NAV_SECTIONS from './navConfig';
import AvatarCircle from '../ui/AvatarCircle';
import { ArrowLeftIcon } from '../ui/icons';

// Navy sidebar in the fact-find Shell.js visual language. Rendered fixed on
// desktop (variant="desktop") and inside the mobile drawer (variant="drawer").
const Sidebar = ({ variant = 'desktop', onNavigate }) => {
    const user = useSelector((s) => s.user);
    const { pathname } = useLocation();

    const go = (path) => {
        history.push(path);
        if (onNavigate) onNavigate();
    };

    const isActive = (item) => {
        const matches = item.match || [item.path];
        return matches.includes(pathname);
    };

    const containerClasses =
        variant === 'desktop'
            ? 'hidden lg:flex flex-col w-72 flex-shrink-0 px-4 py-8 sticky top-0 h-screen'
            : 'flex flex-col w-full h-full px-4 py-6 overflow-y-auto';

    return (
        <aside className={containerClasses} style={{ backgroundColor: '#1A1D2A' }}>
            <div className="mb-8 px-3">
                <img
                    src={process.env.PUBLIC_URL + '/images/logos/light_transparent.png'}
                    alt="LoanGateway"
                    className="h-8 w-auto"
                />
                <p className="text-xs text-[#B5B8C5] mt-2">Admin</p>
            </div>

            <nav className="flex-1 overflow-y-auto pr-1 -mr-1">
                {NAV_SECTIONS.map((section) => (
                    <div key={section.title} className="mb-6">
                        <p className="text-[10px] uppercase tracking-widest text-[#7E8299] mb-2 font-bold px-3">
                            {section.title}
                        </p>
                        <ul className="space-y-0.5">
                            {section.items.map((item) => {
                                const active = isActive(item);
                                const Icon = item.icon;
                                return (
                                    <li key={item.path}>
                                        <button
                                            type="button"
                                            onClick={() => go(item.path)}
                                            className="w-full flex items-center gap-3 rounded-lg px-3 py-2.5 text-left transition-colors"
                                            style={{
                                                backgroundColor: active ? 'rgba(124, 92, 252, 0.15)' : 'transparent',
                                            }}
                                        >
                                            <span style={{ color: active ? '#7C5CFC' : '#7E8299' }}>
                                                <Icon className="h-5 w-5" />
                                            </span>
                                            <span
                                                className="text-sm font-medium"
                                                style={{ color: active ? '#FFFFFF' : '#9CA0AE' }}
                                            >
                                                {item.label}
                                            </span>
                                        </button>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                ))}
            </nav>

            <div className="pt-4 border-t border-[#2A2D3D] mt-4 space-y-1">
                <button
                    type="button"
                    onClick={() => go('/admin/settings/user')}
                    className="w-full flex items-center gap-3 rounded-lg px-3 py-2.5 text-left transition-colors hover:bg-[#232636]"
                    style={{
                        backgroundColor:
                            pathname === '/admin/settings/user' ? 'rgba(124, 92, 252, 0.15)' : 'transparent',
                    }}
                >
                    <AvatarCircle name={user.name} size="sm" />
                    <span className="min-w-0">
                        <span className="block text-sm font-semibold text-white truncate">
                            {user.name || 'Account'}
                        </span>
                        <span className="block text-[11px] text-[#7E8299]">View profile</span>
                    </span>
                </button>
                <button
                    type="button"
                    onClick={() => go('/admin')}
                    className="w-full flex items-center gap-2 rounded-lg px-3 py-2 text-left text-[11px] text-[#7E8299] hover:text-[#C7CAD6] transition-colors"
                >
                    <ArrowLeftIcon className="h-3.5 w-3.5" />
                    Back to classic admin
                </button>
            </div>
        </aside>
    );
};

export default Sidebar;
